import React from "react";
import { Image, Toast } from "react-bootstrap";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
import pictureDE from "../../../../../images/Germany/20231011_fatigue strength curve_DE.png";
import pictureEN from "../../../../../images/Germany/20231011_fatigue strength curve_EN.png";
import pictureES from "../../../../../images/Germany/20231011_fatigue strength curve_ES.png";

function CharakteristischeSpannungsschwingbreiteDetails({ show, setShow }) {
  const { t, i18n } = useTranslation("translation");
  const nodeRef = React.useRef(null);
  const imageSRC =
    i18n.language == "de-DE" ? pictureDE : i18n.language == "es-ES" ? pictureES : pictureEN;

  return (
    <Draggable nodeRef={nodeRef}>
      <Toast
        ref={nodeRef}
        onClose={() => setShow(!show)}
        show={show}
        animation={false}
        style={{
          zIndex: 1000,
          backgroundColor: "white",
          position: "absolute",
          width: "auto",
          height: "auto",
        }}
      >
        <Toast.Header className="d-flex flex-row-reverse"></Toast.Header>
        <Toast.Body>
          <Image src={imageSRC} width={650} alt="" />
        </Toast.Body>
      </Toast>
    </Draggable>
  );
}

export default CharakteristischeSpannungsschwingbreiteDetails;
